import React from "react";
import "./SkillPill.css";

const SkillPill = ({title}) => {

    return (<div className="skill-pill">{title ? title : null}</div>);
};

export default SkillPill;